import { initIndexPage } from "./indexPage";
import { initInfoPage } from "./infoPage";

globalThis.initIndexPage = initIndexPage;

globalThis.initInfoPage = initInfoPage;
